// extracted by mini-css-extract-plugin
export default {"icon":"ScrollbarIcon_icon__btJTz","dot":"ScrollbarIcon_dot__kv6lR","active":"ScrollbarIcon_active__8fakO"};